import Legacy from './legacy-en'
import Home from './home'
import Product from './product'
import General from './general'
import Cart from './cart'
import Search from './search'
import Checkout from './checkout'
import Footer from './footer'
import TeamEvents from './teamevents'
import Login from './login'
import Giftcard from './giftcard'
import Giftcards from './giftcards'
import FaqGiftcard from './faq.giftcard'
import PasswordReset from './password-reset'
import Embedded from './embedded'
import Validation from './validation'
import Survey from './survey'
import Magazine from './magazine'
import Multiselect from './multiselect'
import Review from './review'
import Account from './account'
import EventListPage from './event-list-page'
import SupplierProfile from './supplier-profile'
import Partners from './partner'
import PartnerBookingSolution from './partner-booking-solution'
import Rebook from './rebook'
import Seo from './seo'
import Sitemap from './sitemap'
import Widgets from './widgets'
import Wishlist from './wishlist'
import Offer from './offer'

export default defineI18nLocale(() => {
  return {
    ...Home,
    ...Account,
    ...Review,
    ...Multiselect,
    ...Survey,
    ...Legacy,
    ...Validation,
    ...Embedded,
    ...Product,
    ...General,
    ...Cart,
    ...Search,
    ...Checkout,
    ...Footer,
    ...Login,
    ...Giftcard,
    ...TeamEvents,
    ...Login,
    ...Giftcards,
    ...FaqGiftcard,
    ...PasswordReset,
    ...Magazine,
    ...EventListPage,
    ...SupplierProfile,
    ...Partners,
    ...PartnerBookingSolution,
    ...Rebook,
    ...Seo,
    ...Sitemap,
    ...Widgets,
    ...Wishlist,
    ...Offer,
  }
})
